












































import Vue from 'vue';
import * as relazioneMedicaRelazioneSanitarioApi from '../../services/relazione-medica-relazione-sanitario-api';
import {
    RelazioneMedicaRelazioneSanitarioListViewModel,
    RelazioneMedicaRelazioneSanitario,
} from '../../types';

import relazioneMedicaRelazioneSanitarioEdit from '@/components/commands/RelazioneMedicaRelazioneSanitarioEdit.vue';

export default Vue.extend({
    components: {},
    props: {
        relazioneMedicaId: { required: true, type: Number },
    },
    data(): RelazioneMedicaRelazioneSanitarioListViewModel {
        return {
            columns: [
                {
                    text: this.$i18n.t('labels.operatore-sanitario'),
                    value: 'operatoreSanitario.displayName',
                    width: 200,
                },
                {
                    text: this.$i18n.t('labels.qualifica'),
                    value: 'operatoreSanitario.qualifica.valore',
                    width: 200,
                },
                {
                    text: this.$i18n.t('labels.sintesi-relazione'),
                    value: 'relazione',
                },
            ],
            dataItems: [],
            selectedItems: [],
            dialog: false,
            editComponent: relazioneMedicaRelazioneSanitarioEdit,
            currentEditId: undefined,
        };
    },
    computed: {
        canDelete(): boolean {
            return this.selectedItems.length > 0;
        },
    },
    methods: {
        async loadData(): Promise<void> {
            this.dataItems = await relazioneMedicaRelazioneSanitarioApi.getByRelazioneMedica(
                this.relazioneMedicaId
            );
            this.selectedItems = [];
        },
        showDetail(item: RelazioneMedicaRelazioneSanitario) {
            this.currentEditId = item.id;
            this.dialog = true;
        },
        async deleteItems(): Promise<void> {
            if (
                await this.$confirm(
                    this.$t('dialog.default-question').toString(),
                    {
                        title: this.$t('dialog.delete-title').toString(),
                        color: 'secondary',
                        icon: 'mdi-delete',
                    }
                )
            ) {
                await relazioneMedicaRelazioneSanitarioApi.remove(
                    this.selectedItems.map((p) => {
                        return {
                            id: p.id,
                            version: p.version,
                        };
                    })
                );
                await this.loadData();
            }
        },
        getComponentProps() {
            return {
                relazioneMedicaId: this.relazioneMedicaId,
                id: this.currentEditId,
            };
        },
        dialogClose() {
            this.currentEditId = undefined;
            this.dialog = false;
        },
    },
    async mounted() {
        await this.loadData();
    },
});
